import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { AuthPage } from "./auth/AuthPage";
import { getLang } from "./i18n";
import { AppShell } from "./shell/AppShell";
import { useApp } from "./store";
import "./styles.css";

function App() {
  const session = useApp((s) => s.session);
  const engine = useApp((s) => s.engine);
  return (
    <Routes>
      <Route path="/auth/login" element={session ? <Navigate to="/app/today" replace /> : <AuthPage mode="login" />} />
      <Route
        path="/auth/signup"
        element={session ? <Navigate to="/app/today" replace /> : <AuthPage mode="signup" />}
      />
      <Route path="/auth/token" element={session ? <Navigate to="/app/today" replace /> : <AuthPage mode="token" />} />
      <Route
        path="/app/*"
        element={session && engine ? <AppShell key={session.userId} /> : <Navigate to="/auth/login" replace />}
      />
      <Route path="*" element={<Navigate to={session ? "/app/today" : "/auth/login"} replace />} />
    </Routes>
  );
}

document.documentElement.lang = getLang() === "zh" ? "zh-CN" : "en";

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
